import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=3a17bed2&scoped=true"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"
import style0 from "./Blank.vue?vue&type=style&index=0&id=3a17bed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17bed2",
  null
  
)

export default component.exports